module.exports = __webpack_public_path__ + "static/media/buy_start_service_help_1.9372d8fb.jpg";